import { render, staticRenderFns } from "./MapHeat.vue?vue&type=template&id=f640ffde&"
import script from "./MapHeat.vue?vue&type=script&lang=js&"
export * from "./MapHeat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports